import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@cdm/quickenloans-library/lib';
import useTooltipContent from './useTooltipContent';

const TooltipWithId = ({contentId, ...props}) =>
{
    const content = useTooltipContent( contentId );
    const tooltipProps = {
        ...props,
        content
    }
    return <Tooltip {...tooltipProps} />
}
TooltipWithId.propTypes = 
{
    contentId: PropTypes.string
}

export default TooltipWithId;
